import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const VideoIcon: React.FC<IconProps> = ({
  size = 24,
  color = Colors.role.textStrong,
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    {/* Outer rectangle */}
    <Path d="M23 1H1V23H23V1Z" stroke={color} strokeWidth="2" strokeLinejoin="round" />
    {/* Play button triangle */}
    <Path d="M8 6V18L18 12L8 6Z" stroke={color} strokeWidth="2" strokeLinejoin="round" />
  </Svg>
);

VideoIcon.displayName = 'VideoIcon';
